import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import { fetchM } from '../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../actions/flash';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class AddRemarkModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  };

  static propTypes = {
    open: PropTypes.bool,
    bankCases: PropTypes.array,
    opportunityID: PropTypes.string,
    token: PropTypes.string,
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  static defaultProps = {
    bankCases: [],
  };

  state = {
    remarkMessage: '',
    ccIDs: [],
    loading: false,
  };

  setLoading = loading =>
    new Promise(res => this.setState({ loading }, res));

  isCheckedAll = () => {
    const { ccIDs } = this.state;
    const { bankCases } = this.props;
    if (bankCases.length === 0) return false;
    return ccIDs.length === bankCases.length;
  };

  isChecked = item => this.state.ccIDs.includes(item.id);

  handleCheckBoxAll = () => {
    const { bankCases } = this.props;

    this.setState({
      ccIDs: this.isCheckedAll() ? [] : bankCases.map(c => c.id),
    });
  };

  handleCheckBox = (item) => {
    this.setState((prev) => {
      const exists = prev.ccIDs.includes(item.id);
      return {
        ccIDs: exists
          ? prev.ccIDs.filter(id => id !== item.id)
          : [...prev.ccIDs, item.id],
      };
    });
  };

  handleTextAreaChange = (e) => {
    this.setState({ remarkMessage: e.target.value });
  };

  handleSubmit = async () => {
    const { store } = this.context;
    const { opportunityID, token, onSuccess, onClose } = this.props;
    const { remarkMessage, ccIDs } = this.state;

    if (!opportunityID || !token) return;

    const data = {
      message: remarkMessage,
      type: 'message',
      ccIDs,
    };

    await this.setLoading(true);

    try {
      await store.dispatch(
        fetchM(`/opportunity/${opportunityID}/loan_tracker/activity_logs/`, {
          credentials: 'include',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': token,
          },
          body: JSON.stringify(data),
        }),
      );

      store.dispatch(
        flashSuccessMessage({
          header: 'Success',
          message: 'Remark was successfully added.',
        }),
      );

      // 👇 notify parent if needed
      if (onSuccess) onSuccess();

      // reset state
      this.setState({
        remarkMessage: '',
        ccIDs: [],
      });

      onClose();
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      } else {
        Bugsnag.notifyException(err);
        store.dispatch(
          flashErrorMessage({
            message: 'There was an error with your request. Please try again.',
          }),
        );
      }
    }

    await this.setLoading(false);
  };

  render() {
    const { t, open, bankCases, onClose } = this.props;
    const { remarkMessage, loading } = this.state;

    return (
      <Modal size="tiny" open={open} onClose={onClose}>
        <Modal.Header>{t('Add Remark', { ns: TRANSLATION_FILES.translation })}</Modal.Header>

        <Modal.Content>
          <Form>
            <textarea
              placeholder={t('Type your message here', { ns: TRANSLATION_FILES.translation })}
              onChange={this.handleTextAreaChange}
              value={remarkMessage}
              maxLength="160"
              style={{ resize: 'none', minHeight: '5.5em', width: '100%' }}
            />

            <div style={{ textAlign: 'right' }}>
              <small>{remarkMessage.length} / 160</small>
            </div>

            <Form.Group>
              <small>{t('Notify:', { ns: TRANSLATION_FILES.translation })}</small>

              {bankCases.map((item) => (
                <Form.Checkbox
                  key={item.id}
                  label={item.bank.shortName}
                  onChange={() => this.handleCheckBox(item)}
                  checked={this.isChecked(item)}
                />
              ))}

              <Form.Checkbox
                label={t('All', { ns: TRANSLATION_FILES.translation })}
                onChange={this.handleCheckBoxAll}
                checked={this.isCheckedAll()}
              />
            </Form.Group>
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={onClose}>{t('Cancel', { ns: TRANSLATION_FILES.translation })}</Button>
          <Button
            onClick={this.handleSubmit}
            loading={loading}
            disabled={!remarkMessage}
            primary
            content={t('Add', { ns: TRANSLATION_FILES.translation })}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(AddRemarkModal);



// WEBPACK FOOTER //
// ./src/components/AddRemarkModal.jsx